<div class="lateral-modal-customized fixed-top">
  <div class="box-filter dialog-top">
    <div class="title-custom">
      <img class="icon-title" src="./../../../assets/images/icons/stp_portal/icon_information.svg" alt="Icon" />
      <h3 class="custom-filter">{{ modalName }}</h3>
      <button *ngIf="this.returnList.length > 1" (click)="returnBtn()" class="return-button show">
        <i class="fa-solid fa-arrow-left"></i>
        Return
      </button>
      <span (click)="closeDialog()" class="fa fa-times modal-close" data-dismiss="modal"></span>
    </div>
  </div>
  <div class="box-filter-content">
    <div class="content-filter">
      <div *ngIf="isLoading" class="spinner-content">
        <div class="spinner"></div>
      </div>
      <!-- Top Info -->
      <div class="top-info">
        <!-- Infos -->
        <div class="controls-info">
          <div class="to-left">
            <!-- <div *ngIf="skeletonTable" class="skeleton skeleton-line" style="--c-w: 180px"></div> -->

            <span class="title">
              <b>{{ orderNumber }}: </b>
              {{ clientName ? clientName : '' }}
            </span>
          </div>
          <div class="to-right">
            <span
              *ngIf="soStatus !== undefined"
              class="badge"
              [ngClass]="{
                'bg-danger': soStatus === 'Delayed',
                'bg-success': soStatus === 'Completed',
                'bg-progress': soStatus === 'In Progress',
                'bg-bbacklog': soStatus === 'Billing Block',
                'bg-canceled': soStatus === 'Cancelled'
              }"
              >{{ soStatus ? soStatus : '' }}</span
            >
          </div>
        </div>
      </div>
      <!--Skeleton Tables-->
      <div class="col-xl-12 content pt-0">
        <div class="global-content-skeleton">
          <table *ngIf="skeletonTable" class="tb-warehouse tb-skeleton">
            <thead>
              <tr>
                <th>
                  <div class="skeleton skeleton-line" style="--c-w: 180px"></div>
                </th>
                <th>
                  <div class="skeleton skeleton-line" style="--c-w: 180px"></div>
                </th>
                <th>
                  <div class="skeleton skeleton-line" style="--c-w: 180px"></div>
                </th>
                <th>
                  <div class="skeleton skeleton-line" style="--c-w: 180px"></div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of repeatSk">
                <td>
                  <div class="skeleton skeleton-line" style="--c-w: 120px; --l-h: 18px"></div>
                </td>
                <td>
                  <div class="skeleton skeleton-line" style="--c-w: 120px; --l-h: 18px"></div>
                </td>
                <td>
                  <div class="skeleton skeleton-line" style="--c-w: 120px; --l-h: 18px"></div>
                </td>
                <td>
                  <div class="skeleton skeleton-line" style="--c-w: 120px; --l-h: 18px"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--Summarized Table-->

      <!--Contents-->
      <div class="col-xl-12 content" *ngIf="!skeletonTable">
        <div class="to-left">
          <h1>
            Detailed Informations <small>( {{ this.tableResp.rowData.length | number: '1.0-0' }} registers )</small>
          </h1>
        </div>

        <app-table-ag-grid
          *ngIf="tableResp"
          [respTable]="tableResp"
          [exportCsv]="false"
          (customCellClick)="onCustomCellClick($event)"
          [csvToLeft]="false"
          [height]="'90%'"
          class="ag-billing"
        ></app-table-ag-grid>

        <div *ngIf="!skeletonTable && financial?.length === 0" class="not-found table">
          <img src="../../../assets/images/icons/not_tasks.png" alt="No data found." class="img-notFound" />
          No data found. <strong></strong>
          <p>No data was found for this search.</p>
        </div>
      </div>
    </div>
    <!-- Expand Button -->
    <div *ngIf="skeletonTable" class="col-xl-12 actions-footer">
      <div class="skeleton skeleton-line" style="--c-w: 120px; --l-h: 18px"></div>
    </div>

    <div *ngIf="!skeletonTable" class="col-xl-12 actions-footer">
      <button *ngIf="!showMore" mat-flat-button class="btn-show" (click)="showMoreLess()">
        <img class="icon-button" src="./../../../assets/images/icons/stp_portal/icon_prev.svg" alt="Icon" /> show more
      </button>
      <button *ngIf="showMore" mat-flat-button class="btn-show" (click)="showMoreLess()">
        <img
          class="icon-button"
          style="transform: rotate(180deg)"
          src="./../../../assets/images/icons/stp_portal/icon_prev.svg"
          alt="Icon"
        />
        show less
      </button>
    </div>
  </div>
</div>
